/* lua.js generated code 0.3.0 */

/* 
Copyright (c) 2011-2014 chukong-inc.com

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

 */
var display = table()
var director = cc.Director.getInstance()
var view = director.getOpenGLView()
if (!view) {
    var width = 960
    var height = 640
    if (CC_DESIGN_RESOLUTION) {
        if (CC_DESIGN_RESOLUTION.width) {
            width = CC_DESIGN_RESOLUTION.width
        }
        if (CC_DESIGN_RESOLUTION.height) {
            height = CC_DESIGN_RESOLUTION.height
        }
    }
    view = cc.GLViewImpl.createWithRect("Cocos2d-Lua", cc.rect(0, 0, width, height))
    director.setOpenGLView(view)
}

function checkResolution(r) {
    r.width = checknumber(r.width)
    r.height = checknumber(r.height)
    r.autoscale = string.upper(r.autoscale)
    assert(r.width > 0 && r.height > 0, `display - invalid design resolution size ${r.width}, ${r.height}`)
}
function setDesignResolution(r, framesize) {
    if (r.autoscale === "FILL_ALL") {
        view.setDesignResolutionSize(framesize.width, framesize.height, cc.ResolutionPolicy.FILL_ALL)
    } else {
        var [scaleX, scaleY] = [framesize.width / r.width, framesize.height / r.height]
        var [width, height] = [framesize.width, framesize.height]
        if (r.autoscale === "FIXED_WIDTH") {
            width = framesize.width / scaleX
            height = framesize.height / scaleX
            view.setDesignResolutionSize(width, height, cc.ResolutionPolicy.NO_BORDER)
        } else if (r.autoscale === "FIXED_HEIGHT") {
            width = framesize.width / scaleY
            height = framesize.height / scaleY
            view.setDesignResolutionSize(width, height, cc.ResolutionPolicy.NO_BORDER)
        } else if (r.autoscale === "EXACT_FIT") {
            view.setDesignResolutionSize(r.width, r.height, cc.ResolutionPolicy.EXACT_FIT)
        } else if (r.autoscale === "NO_BORDER") {
            view.setDesignResolutionSize(r.width, r.height, cc.ResolutionPolicy.NO_BORDER)
        } else if (r.autoscale === "SHOW_ALL") {
            view.setDesignResolutionSize(r.width, r.height, cc.ResolutionPolicy.SHOW_ALL)
        } else {
            printError(string.format("display - invalid r.autoscale \"%s\"", r.autoscale))
        }
    }
}
function setConstants() {
    var sizeInPixels = view.getFrameSize()
    display.sizeInPixels = { width: sizeInPixels.width, height: sizeInPixels.height }
    var viewsize = director.getWinSize()
    display.contentScaleFactor = director.getContentScaleFactor()
    display.size = { width: viewsize.width, height: viewsize.height }
    display.width = display.size.width
    display.height = display.size.height
    display.cx = display.width / 2
    display.cy = display.height / 2
    display.c_left = -display.width / 2
    display.c_right = display.width / 2
    display.c_top = display.height / 2
    display.c_bottom = -display.height / 2
    display.left = 0
    display.right = display.width
    display.top = display.height
    display.bottom = 0
    display.center = cc.p(display.cx, display.cy)
    display.left_top = cc.p(display.left, display.top)
    display.left_bottom = cc.p(display.left, display.bottom)
    display.left_center = cc.p(display.left, display.cy)
    display.right_top = cc.p(display.right, display.top)
    display.right_bottom = cc.p(display.right, display.bottom)
    display.right_center = cc.p(display.right, display.cy)
    display.top_center = cc.p(display.cx, display.top)
    display.top_bottom = cc.p(display.cx, display.bottom)
    if (__DEBUG) {
        printInfo(string.format("# display.sizeInPixels         = {width = %0.2f, height = %0.2f}", display.sizeInPixels.width, display.sizeInPixels.height))
        printInfo(string.format("# display.size                 = {width = %0.2f, height = %0.2f}", display.size.width, display.size.height))
        printInfo(string.format("# display.contentScaleFactor   = %0.2f", display.contentScaleFactor))
        printInfo(string.format("# display.width                = %0.2f", display.width))
        printInfo(string.format("# display.height               = %0.2f", display.height))
        printInfo(string.format("# display.cx                   = %0.2f", display.cx))
        printInfo(string.format("# display.cy                   = %0.2f", display.cy))
        printInfo(string.format("# display.left                 = %0.2f", display.left))
        printInfo(string.format("# display.right                = %0.2f", display.right))
        printInfo(string.format("# display.top                  = %0.2f", display.top))
        printInfo(string.format("# display.bottom               = %0.2f", display.bottom))
        printInfo(string.format("# display.c_left               = %0.2f", display.c_left))
        printInfo(string.format("# display.c_right              = %0.2f", display.c_right))
        printInfo(string.format("# display.c_top                = %0.2f", display.c_top))
        printInfo(string.format("# display.c_bottom             = %0.2f", display.c_bottom))
        printInfo(string.format("# display.center               = {x = %0.2f, y = %0.2f}", display.center.x, display.center.y))
        printInfo(string.format("# display.left_top             = {x = %0.2f, y = %0.2f}", display.left_top.x, display.left_top.y))
        printInfo(string.format("# display.left_bottom          = {x = %0.2f, y = %0.2f}", display.left_bottom.x, display.left_bottom.y))
        printInfo(string.format("# display.left_center          = {x = %0.2f, y = %0.2f}", display.left_center.x, display.left_center.y))
        printInfo(string.format("# display.right_top            = {x = %0.2f, y = %0.2f}", display.right_top.x, display.right_top.y))
        printInfo(string.format("# display.right_bottom         = {x = %0.2f, y = %0.2f}", display.right_bottom.x, display.right_bottom.y))
        printInfo(string.format("# display.right_center         = {x = %0.2f, y = %0.2f}", display.right_center.x, display.right_center.y))
        printInfo(string.format("# display.top_center           = {x = %0.2f, y = %0.2f}", display.top_center.x, display.top_center.y))
        printInfo(string.format("# display.top_bottom           = {x = %0.2f, y = %0.2f}", display.top_bottom.x, display.top_bottom.y))
        printInfo("#")
    }
}
display.setAutoScale = function (configs) {
    if (type(configs) !== "table") {
        return
    }
    var framesize = view.getFrameSize()
    checkResolution(configs)
    if (type(configs.callback) === "function") {
        var c = configs.callback(framesize)[0] || table()
        for (var k in c) {
            configs[k] = c[k]
        }
        checkResolution(configs)
    }
    setDesignResolution(configs, framesize)
    if (__DEBUG) {
        printInfo(string.format("# design resolution size       = {width = %0.2f, height = %0.2f}", configs.width, configs.height))
        printInfo(string.format("# design resolution autoscale  = %s", configs.autoscale))
    }
    setConstants()
}
if (type(CC_DESIGN_RESOLUTION) === "table") {
    display.setAutoScale(CC_DESIGN_RESOLUTION)
}
setConstants()

// display.COLOR_WHITE = cc.c3b(255, 255, 255)
// display.COLOR_BLACK = cc.c3b(0, 0, 0)
// display.COLOR_RED = cc.c3b(255, 0, 0)
// display.COLOR_GREEN = cc.c3b(0, 255, 0)
// display.COLOR_BLUE = cc.c3b(0, 0, 255)
// display.AUTO_SIZE = 0
// display.FIXED_SIZE = 1
// display.LEFT_TO_RIGHT = 0
// display.RIGHT_TO_LEFT = 1
// display.TOP_TO_BOTTOM = 2
// display.BOTTOM_TO_TOP = 3
// display.CENTER = cc.p(0.5, 0.5)
// display.LEFT_TOP = cc.p(0, 1)
// display.LEFT_BOTTOM = cc.p(0, 0)
// display.LEFT_CENTER = cc.p(0, 0.5)
// display.RIGHT_TOP = cc.p(1, 1)
// display.RIGHT_BOTTOM = cc.p(1, 0)
// display.RIGHT_CENTER = cc.p(1, 0.5)
// display.CENTER_TOP = cc.p(0.5, 1)
// display.CENTER_BOTTOM = cc.p(0.5, 0)
// display.SCENE_TRANSITIONS = table(
//     [1, "CROSSFADE", cc.TransitionCrossFade],
//     [1, "FADE", table([0, cc.TransitionFade], [0, cc.c3b(0, 0, 0)])],
//     [1, "FADEBL", cc.TransitionFadeBL],
//     [1, "FADEDOWN", cc.TransitionFadeDown],
//     [1, "FADETR", cc.TransitionFadeTR],
//     [1, "FADEUP", cc.TransitionFadeUp],
//     [1, "FLIPANGULAR", table([0, cc.TransitionFlipAngular], [0, cc.TRANSITION_ORIENTATION_LEFT_OVER])],
//     [1, "FLIPX", table([0, cc.TransitionFlipX], [0, cc.TRANSITION_ORIENTATION_LEFT_OVER])],
//     [1, "FLIPY", table([0, cc.TransitionFlipY], [0, cc.TRANSITION_ORIENTATION_UP_OVER])],
//     [1, "JUMPZOOM", cc.TransitionJumpZoom],
//     [1, "MOVEINB", cc.TransitionMoveInB],
//     [1, "MOVEINL", cc.TransitionMoveInL],
//     [1, "MOVEINR", cc.TransitionMoveInR],
//     [1, "MOVEINT", cc.TransitionMoveInT],
//     [1, "PAGETURN", table([0, cc.TransitionPageTurn], false)],
//     [1, "ROTOZOOM", cc.TransitionRotoZoom],
//     [1, "SHRINKGROW", cc.TransitionShrinkGrow],
//     [1, "SLIDEINB", cc.TransitionSlideInB],
//     [1, "SLIDEINL", cc.TransitionSlideInL],
//     [1, "SLIDEINR", cc.TransitionSlideInR],
//     [1, "SLIDEINT", cc.TransitionSlideInT],
//     [1, "SPLITCOLS", cc.TransitionSplitCols],
//     [1, "SPLITROWS", cc.TransitionSplitRows],
//     [1, "TURNOFFTILES", cc.TransitionTurnOffTiles],
//     [1, "ZOOMFLIPANGULAR", cc.TransitionZoomFlipAngular],
//     [1, "ZOOMFLIPX", table([0, cc.TransitionZoomFlipX], [0, cc.TRANSITION_ORIENTATION_LEFT_OVER])],
//     [1, "ZOOMFLIPY", table([0, cc.TransitionZoomFlipY], [0, cc.TRANSITION_ORIENTATION_UP_OVER])]
// )
display.TEXTURES_PIXEL_FORMAT = table()
// display.DEFAULT_TTF_FONT = "Arial"
// display.DEFAULT_TTF_FONT_SIZE = 32
var PARAMS_EMPTY = table()
var RECT_ZERO = cc.rect(0, 0, 0, 0)
// var sceneIndex = 0
// display.newScene = function (name, params) {
//     params = params || PARAMS_EMPTY
//     sceneIndex = sceneIndex + 1
//     var scene
//     if (!params.physics) {
//         scene = cc.Scene.create()
//     } else {
//         scene = cc.Scene.createWithPhysics()
//     }
//     scene.name_ = string.format("%s:%d", name || "<unknown-scene>", sceneIndex)
//     if (params.transition) {
//         scene = display.wrapSceneWithTransition(scene, params.transition, params.time, params.more)
//     }
//     return scene
// }
// display.wrapScene = function (scene, transition, time, more) {
//     var key = string.upper(tostring(transition))
//     if (key === "RANDOM") {
//         var keys = table.keys(display.SCENE_TRANSITIONS)
//         key = keys[math.random(1, $len(keys))]
//     }
//     if (display.SCENE_TRANSITIONS[key]) {
//         var t = display.SCENE_TRANSITIONS[key]
//         time = time || 0.2
//         more = more || t[2]
//         if (type(t) === "table") {
//             scene = t[1].create(time, scene, more)
//         } else {
//             scene = t.create(time, scene)
//         }
//     } else {
//         error(string.format("display.wrapScene() - invalid transition %s", tostring(transition)))
//     }
//     return scene
// }
// display.runScene = function (newScene, transition, time, more) {
//     if (director.getRunningScene()) {
//         if (transition) {
//             newScene = display.wrapScene(newScene, transition, time, more)
//         }
//         director.replaceScene(newScene)
//     } else {
//         director.runScene(newScene)
//     }
// }

// start --
//------------------------------
// Create a Filtered Sprite
// @function [parent=#display] newFilteredSprite
// @param mixed filename As same a the first parameter for display.newSprite
// @param mixed filters One of the following:
// @param table params A or some parameters for Filter.
// @return FilteredSprite#FilteredSprite ret (return value: cc.FilteredSprite)
// end --
display.newFilteredSprite = function (filename, filters, params) {
    // FIXME: filter
    return display.newSprite(filename, null, null, null)
    var __one = table([1, "class", cc.FilteredSpriteWithOne])
    var __multi = table([1, "class", cc.FilteredSpriteWithMulti])
    if (!filters) {
        // WARN: maybe multi result
        return display.newSprite(filename, null, null, __one)
    }
    var __sp = null
    var __type = type(filters)
    if (__type === "userdata") {
        __type = tolua.type(filters)
    }
    //print("display.newFSprite type:", __type)
    if (__type === "string") {
        __sp = display.newSprite(filename, null, null, __one)
        // filters = filter.newFilter(filters, params)
        __sp.setFilter(filters)
    } else if (__type === "table") {
        assert($len(filters) > 1, "display.newFilteredSprite() - Please give me 2 or more filters!")
        __sp = display.newSprite(filename, null, null, __multi)
        if (type(filters[1]) === "string") {
            __sp.setFilters(filter.newFilters(filters, params))
        } else {
            // treat filters as {Filter, Filter , ...}
            var __filters = cc.Array.create()
            for (var i = 1, $t40 = filters[1]; $t40; i++ , $t40 = filters[i]) {
                __filters.addObject(filters[i])
            }
            __sp.setFilters(__filters)
        }
    } else if (__type === "Array") {
        // treat filters as Array(Filter, Filter, ...)
        __sp = display.newSprite(filename, null, null, __multi)
        __sp.setFilters(filters)
    } else {
        // treat filters as Filter
        __sp = display.newSprite(filename, null, null, __one)
        __sp.setFilter(filters)
    }
    return __sp
}
display.newGroupFilteredSprite = function (filters, params) {
    // FIXME: filter
    return display.newSprite(null, null, null, null)
    var __one = table([1, "class", cc.GroupFilteredSpriteWithOne])
    var __multi = table([1, "class", cc.GroupFilteredSpriteWithMulti])
    if (!filters) {
        // WARN: maybe multi result
        return display.newSprite(null, null, null, __one)
    }
    var __sp = null
    var __type = type(filters)
    if (__type === "userdata") {
        __type = tolua.type(filters)
    }
    //print("display.newFSprite type:", __type)
    if (__type === "string") {
        __sp = display.newSprite(null, null, null, __one)
        filters = filter.newFilter(filters, params)
        __sp.setFilter(filters)
    } else if (__type === "table") {
        assert($len(filters) > 1, "display.newGroupFilteredSprite() - Please give me 2 or more filters!")
        __sp = display.newSprite(null, null, null, __multi)
        if (type(filters[1]) === "string") {
            __sp.setFilters(filter.newFilters(filters, params))
        } else {
            // treat filters as {Filter, Filter , ...}
            var __filters = cc.Array.create()
            for (var i = 1, $t47 = filters[1]; $t47; i++ , $t47 = filters[i]) {
                __filters.addObject(filters[i])
            }
            __sp.setFilters(__filters)
        }
    } else if (__type === "Array") {
        // treat filters as Array(Filter, Filter, ...)
        __sp = display.newSprite(null, null, null, __multi)
        __sp.setFilters(filters)
    } else {
        // treat filters as Filter
        __sp = display.newSprite(null, null, null, __one)
        __sp.setFilter(filters)
    }
    return __sp
}
display.newSprite = function (source, x, y, params) {
    var scale9 = false
    var params = params || PARAMS_EMPTY
    var spriteClass = params.class
    var size = params.size
    if (!spriteClass) {
        if (params.scale9 || params.capInsets) {
            spriteClass = ccui.Scale9Sprite
            scale9 = true
            params.capInsets = params.capInsets || RECT_ZERO
            params.rect = params.rect || RECT_ZERO
        } else {
            spriteClass = cc.Sprite
        }
    }
    var sprite
    while (true) {
        // create sprite
        if (!source) {
            sprite = spriteClass.create()
            break
        }
        var sourceType = type(source)
        if (sourceType === "string") {
            if (string.byte(source)[0] === 35) { // first char is #
                // create sprite from spriteFrame
                if (!scale9) {
                    sprite = spriteClass.createWithSpriteFrameName(string.sub(source, 2))
                } else {
                    sprite = spriteClass.createWithSpriteFrameName(string.sub(source, 2), params.capInsets)
                }
                break
            }
            // create sprite from image file
            if (display.TEXTURES_PIXEL_FORMAT[source]) {
                cc.Texture2D.setDefaultAlphaPixelFormat(display.TEXTURES_PIXEL_FORMAT[source])
            }
            if (!scale9) {
                sprite = spriteClass.create(source)
            } else {
                sprite = spriteClass.create(source, params.rect, params.capInsets)
            }
            if (display.TEXTURES_PIXEL_FORMAT[source]) {
                cc.Texture2D.setDefaultAlphaPixelFormat(cc.TEXTURE2_D_PIXEL_FORMAT_BGR_A8888)
            }
            break
        }
        //  else if (sourceType !== "userdata") {
        //     error(string.format("display.newSprite() - invalid source type \"%s\"", sourceType), 0)
        // } 
        else {
            // sourceType = tolua.type(source)
            if (source instanceof cc.SpriteFrame) {
                if (!scale9) {
                    sprite = spriteClass.createWithSpriteFrame(source)
                } else {
                    sprite = spriteClass.createWithSpriteFrame(source, params.capInsets)
                }
            } else if (source instanceof cc.Texture2D) {
                sprite = spriteClass.createWithTexture(source)
            } else {
                error(string.format("display.newSprite() - invalid source type \"%s\"", sourceType), 0)
            }
        }
        break
    }
    if (sprite) {
        if (x && y) {
            sprite.setPosition(x, y)
        }
        if (params.size) {
            sprite.setContentSize(params.size)
        }
    } else {
        error(string.format("display.newSprite() - create sprite failure, source \"%s\"", tostring(source)), 0)
    }
    sprite.setFilters = function () { }
    return sprite
}

module.exports = display
